<template>
  <div class="project-cross-team-detail" v-loading="loading">
    <div class="project-cross-team-detail-top">
      <div class="project-name">
        <i class="icon iconfont iconicon_arrow_task_2 activeIconHover" @click="handleBack"></i>
        <!-- 背景选择 -->
        <el-tooltip content="编辑背景" v-model="colorTooltip" :disabled="!(isBoss || isAdmin || $permission('项目管理-更新项目'))">
          <ColorCardSmall
          :dataset="projectInfo"
          @change="colorChange"
          :defaultText="projectInfo.project_name"
          class="project-bread-color"
          :disabled="!(isBoss || isAdmin || $permission('项目管理-更新项目'))"
          @visibleChange="colorVisibleChange">
          </ColorCardSmall>
        </el-tooltip>
        <toolTip :title="projectInfo.project_name" :maxWidth="'734px'">
          <p class="tit">{{ projectInfo.project_name }}</p>
        </toolTip>
        <el-tooltip effect="dark" content="项目详情" placement="top">
          <i @click="projectDetailDialogShow = true" class="icon iconfont iconicon_help_nor activeStyle activeIconHover"></i>
        </el-tooltip>
      </div>
      <div class="project-set-wrap">
        <Project-members-popover
          :id="id"
          :membersLength="membersLength"
          :isHide="isHide"
          :membersArr="membersArr"
          :membersUidArr="membersUidArr"
          :membersDataList="membersDataList"
          :addOrDelPermission="addOrDelPermission"
          :setAdminPermission="setAdminPermission"
          @handleMembersHide="handleMembersHide"
          @handleSearchMember="handleSearchMember"
        ></Project-members-popover>

        <!-- <el-popover trigger="click" @hide="handleMembersHide">
          <div class="project-set-members-box">
            <Members
              :id="id"
              :num="membersLength"
              :isHide="isHide"
              :membersUidArr="membersUidArr"
              :membersDataList="membersDataList"
              :addOrDelPermission="addOrDelPermission"
              :setAdminPermission="setAdminPermission"
              @handleSearchMember="handleSearchMember"
            ></Members>
          </div>
          <div class="members-wrap" slot="reference">
            <ul>
              <li v-for="item of membersArr.slice(0, 5)" :key="item.uid">
                <Myavatar
                  width="28px"
                  height="28px"
                  fontSize="12px"
                  :imgUrl="item.user_avatar"
                  :userName="item.realname"
                ></Myavatar>
              </li>
            </ul>
            <i class="icon iconfont iconicon_enlarge" v-if="addOrDelPermission"></i>
          </div>
        </el-popover> -->

        <em></em>
        <MessageInfo
        :cross_project_id="id"
        :messageListTotal="messageListTotal"
        >
        </MessageInfo>
        <i
          v-if="crossProjectSettingPermission"
          class="icon iconfont iconicon_setting_project project_set activeIconHover"
          @click="handleSet"
        ></i>
      </div>
    </div>

    <div class="project-container">
      <div class="progress">
        <Circular-progress :percents="usingRate"></Circular-progress>
        <!-- <Ball :usingRate="usingRate"></Ball> -->
        <div class="progress-text">
          <div class="progress-text-box">
            <span>{{ undoneNum }}</span>
            <p>未完成</p>
          </div>
          <div class="progress-text-box">
            <span class="expire">{{ overdueNum }}</span>
            <p>逾期</p>
          </div>
        </div>
      </div>
      <div class="milepost">
        <div class="milepost-top">
          <div class="milepost-top-left">
            <!-- <img src="image/icon/icon_milepost.png" alt=""> -->
            <p>里程碑</p>
            <span>
              {{ `（${milepostFinishNum}/${projectInfo.milestones ? projectInfo.milestones.length : 0}）` }}
            </span>
          </div>
          <div class="milepost-top-right activeIconHover" v-if="addOrUpdateMilestonePermission" @click="handleAddMilepost">
            <i class="icon iconfont iconicon_enlarge"></i>
            <p>创建</p>
          </div>
        </div>
        <nothing v-if="projectInfo.milestones && !projectInfo.milestones.length" :config="nothingConfig"></nothing>
        <div class="milepost-con">
          <div class="line-wrap">
            <!-- <span class="is-finish" :style="{'width' : `${milepostWidth}%`}"></span> -->
            <span class="line" :style="{ 'width': `${milepostWidth}px` }"></span>
          </div>
          <ul>
            <li
              v-for="(item, index) of projectInfo.milestones"
              :key="item.id"
              :class="{'finish': item.milestone_status === 1 || index === 0}"
              @click="handleCheckMilepost(item.id)"
            >
              <div class="point-wrap">
                <i v-if="item.milestone_status === 1" class="icon iconfont iconicon_selected_files point"></i>
                <!-- <span v-if="item.milestone_status === 1" class="point"></span> -->
                <span v-else class="num">{{ index + 1 }}</span>
              </div>
              <toolTip :title="item.milestone_name" :maxWidth="'100%'">
                <span>{{item.milestone_name}}</span>
              </toolTip>
              <!-- <p class="tit">{{ item.milestone_name }}</p> -->
              <p class="date">{{ item.end_date.replaceAll('-', '/') }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="project-child">
      <div class="project-child-top">
        <div class="project-child-top-left">
          <!-- <img src="image/icon/icon_subproject.png" alt=""> -->
          <p>子项目</p>
          <span>{{ projectInfo.projects ? `（${ projectInfo.projects.length }）` : '（0）' }}</span>
        </div>
        <div class="project-child-right">
          <el-dropdown trigger="click" v-if="joinOrRemoveSubproject">
            <div class="el-dropdown-link activeIconHover">
              <i class="icon iconfont iconicon_enlarge"></i>
              <p>创建</p>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div class="dropdown-item" @click="handleNewSubproject">
                  <i class="icon iconfont iconicon_new_subproject"></i>
                  新建子项目
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="dropdown-item" @click="handleAddSubproject">
                  <i class="icon iconfont iconicon_add_item"></i>
                  添加已有项目
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>
      </div>
      <div class="project-child-container">
        <nothing v-if="projectInfo.projects && !projectInfo.projects.length" :config="{}"></nothing>
        <PojectItem
          v-for="innerItem in projectInfo.projects"
          :projectInfo="innerItem"
          :key="innerItem.project_id"
          :depId="innerItem.project_depart_id"
          :joinOrRemoveSubproject="joinOrRemoveSubproject"
          @update="handleUpdate"
        >
        </PojectItem>
      </div>
    </div>

    <!-- 项目设置弹窗 -->
    <el-drawer
      :wrapperClosable="false"
      :visible.sync="projectSetVisible"
      :modal="false"
      title="编辑项目"
    >
      <Set-project-dialog
        :id="id"
        :editVisible="projectSetVisible"
        @update="handleUpdate"
        @projectSuccess="projectSuccess"
        @delSuccess="delSuccess"
        @colorChange="init"
      >
      </Set-project-dialog>
    </el-drawer>

    <!-- 里程碑设置弹窗 -->
    <Milepost-dialog
      :dialogShow="milepostDialogShow"
      :id="milePostId"
      :crossPojectId="id"
      :readonly="!addOrUpdateMilestonePermission"
      :updateMilestoneStatus="updateMilestoneStatus"
      @update="handleUpdate"
      @handleClose="handleDialogClose"
    ></Milepost-dialog>

    <!-- 新增子项目弹窗 -->
    <New-subproject-dialog
      :dialogShow="newSubprojectDialogShow"
      :crossPojectId="id"
      @update="handleUpdate"
      @handleClose="handleDialogClose"
    ></New-subproject-dialog>

    <!-- 添加子项目弹窗 -->
    <Add-subproject-dialog
      :crossProjectId="id"
      :dialogShow="addSubprojectDialogShow"
      @update="handleUpdate"
      @handleClose="handleDialogClose"
    ></Add-subproject-dialog>

    <!-- 跨团队项目详情弹窗 -->
    <Project-detail-dialog
      v-model="projectDetailDialogShow"
      :id="id"
    >
    </Project-detail-dialog>

  </div>
</template>

<script>
//组件
import CircularProgress from '@/components/circularProgress'
// import Ball from '@/views/statistics/ball.vue'
import Myavatar from "@/components/avatar/index"
import Bit from "@/components/bit";
import ToolTip from '@/components/toolTip'
import Members from './components/members.vue'
import PojectItem from './components/projectItem.vue'
import SetProjectDialog from './components/setProjectDialog.vue'
import MilepostDialog from './components/milepostDialog.vue'
import NewSubprojectDialog from './components/newSubprojectDialog.vue'
import AddSubprojectDialog from './components/addSubprojectDialog.vue'
import ProjectDetailDialog from '../detail.vue'
import ProjectMembersPopover from '@/components/projectMembersPopover/index.vue'
import MessageInfo from '@/components/messageInfo'
import ColorCardSmall from '@/components/colorControl/cardSmall'
import { mapMutations } from 'vuex'
//api
import api from '@/services/api/home/home'
import apiMsg from '@/services/api/realMessage/realMessage'
import projectApi from '@/services/api/project/project'
import { Storage } from "@/utils/utils";
export default {
  name: 'projectCrossTeamDetail',
  components: {
    CircularProgress,
    // Ball,
    Bit,
    Myavatar,
    ToolTip,
    Members,
    PojectItem,
    SetProjectDialog,
    MilepostDialog,
    NewSubprojectDialog,
    AddSubprojectDialog,
    ProjectDetailDialog,
    ProjectMembersPopover,
    MessageInfo,
    ColorCardSmall
  },
  created() {
    this.id = Number(this.$route.query.id)
    this.init() //初始化获取项目详情
    this.getMembers() //初始化获取项目成员
    // console.log(this.isBoss, 1111)
  },
  computed: {
    crossProjectSettingPermission() { // 项目设置权限
      return this.projectInfo.permissions ? this.projectInfo.permissions.cross_project_setting_permission : false
    },
    addOrDelPermission() { // 增/删成员权限
      return this.projectInfo.permissions ? this.projectInfo.permissions.add_or_delete_permission : false
    },
    setAdminPermission() { // 设置项目管理员权限
      return this.projectInfo.permissions ? this.projectInfo.permissions.set_admin_permission : false
    },
    addOrUpdateMilestonePermission() { // 增/改里程碑权限
      return this.projectInfo.permissions ? this.projectInfo.permissions.add_or_update_milestone : false
    },
    updateMilestoneStatus() { // 更改里程碑状态权限
      return this.projectInfo.permissions ? this.projectInfo.permissions.update_milestone_status : false
    },
    joinOrRemoveSubproject() { // 增/删子项目权限
      return this.projectInfo.permissions ? this.projectInfo.permissions.join_or_remove_subproject : false
    },
    //是否是CEO、项目创建者
    hasPermission() {
      const _uid = localStorage.getItem('wfUserInfo').uid //拿到用户的uid
      const createrUid = this.projectInfo.created_user ? this.projectInfo.created_user.uid : null

      return this.isBoss || _uid === createrUid
    }
  },
  data() {
    return  {
      id: null,
      loading: false,
      projectInfo: {},
      isHide: false, //成员浮窗是否关闭
      membersArr: [], //项目成员数据数组
      membersUidArr: [], //项目成员uid组成的数组
      membersLength: 0, //项目所有成员的数量
      membersDataList: {}, //项目成员集合对象，包括部门名称 ('部门名称: [项目成员]'这样的对象模式)
      usingRate: 0,//子任务完成百分比
      undoneNum: 0,//未完成任务数
      overdueNum: 0,//逾期任务数
      milepostFinishNum: 0, //里程碑完成数
      projectSetVisible: false, //项目设置的弹窗控制
      milepostWidth: 0,
      milePostId: 0,
      messageListTotal: 0,
      milepostDialogShow: false,
      newSubprojectDialogShow: false,
      addSubprojectDialogShow: false,
      projectDetailDialogShow: false,
      colorTooltip: false, // 背景颜色浮窗开关
      nothingConfig: {
        type: 'img_add_task',
        tip: '暂无里程碑'
      }
    }
  },
  methods: {
    ...mapMutations('cross/cross', ['SET_ACTIVE']),
    async init() {
      this.loading = true
      this.undoneNum = 0
      this.overdueNum = 0
      this.milepostFinishNum = 0
      const _ts = this
      const res = await api.getCrosssProjectsDetail({ id: this.id })
      if (res) {
        this.projectInfo = res

        //任务
        const _projects = this.projectInfo.projects
        if (_projects && _projects.length) {
          let total = 0 //任务总数
          let complete = 0 //已完成数量、
          for(let i = 0, len = _projects.length; i < len; i++) {
            // total = total + _projects[i].Overview.total_number_of_tasks
            complete = complete + _projects[i].Overview.project_progress

            _ts.undoneNum = _ts.undoneNum + _projects[i].Overview.undone_number_of_tasks //未完成
            _ts.overdueNum = _ts.overdueNum + _projects[i].Overview.overdue_number_of_tasks //逾期
          }
          this.usingRate = Math.floor(complete / _projects.length) | 0 //子任务完成百分比
        }

        //里程碑
        const _milestones = this.projectInfo.milestones
        if (_milestones && _milestones.length) {
          for(let i = 0, len = _milestones.length; i < len; i++) {
            if (_milestones[i].milestone_status === 1) {
              _ts.milepostFinishNum++
            }
          }
        }
        //计算里程碑已完成长度
        // this.milepostWidth = (_ts.milepostFinishNum / (_milestones.length - 1) * 100).toFixed(2)
        // _ts.milepostWidth = _ts.milepostFinishNum > 1 ?  (_ts.milepostFinishNum - 1) * 156 : 0
        _ts.milepostWidth = _milestones.length  > 1 ?  (_milestones.length  - 1) * 208 : 0

        _ts.loading = false
      }
      this.fetchProjectUnreadMessage() // 获取消息数量，显示角标使用
    },
    async getMembers (keywords) {
      const param = {
        cross_project_id: this.id,
        keyword: keywords
      }
      const res = await api.getCrossProjectsMembers(param)
      if (res) {
        this.membersDataList = {}
        this.membersArr = keywords ? this.membersArr : []

        for (let key in res) {
          if (res[key].length) {
            if (!keywords) {
              //有搜索关键字，不可改变现有成员显示
              this.membersArr.push(...res[key]) //获取成员形成一个数组
              //获取所有成员uid组成一个数组
              this.membersUidArr = this.membersArr.map(item => { return item.uid })
            }
            this.membersDataList[key] = res[key] //获取成员及部门
          }
        }

        this.membersLength = this.membersArr.length
      }
    },
    //搜索成员
    handleSearchMember(keywords, needInit) {
      this.isHide = false
      this.getMembers(keywords)
      if (needInit) this.init() //需要刷新跨团队项目进度详情
    },
    handleUpdate() {
      this.projectSetVisible = false
      this.editVisible = false
      this.milePostId = 0
      this.milepostDialogShow = false
      this.newSubprojectDialogShow = false
      this.addSubprojectDialogShow = false
      this.$nextTick(() => {
        this.init()
      })

    },
    handleMembersHide() {
      this.isHide = true
    },
    handleBack() {
      this.SET_ACTIVE('2')
      this.$router.push('./crossProject')
    },
    handleSet() {
      this.projectSetVisible = true
    },
    projectSuccess() {

    },
    delSuccess() {

    },
    handleAddMilepost() {
      this.milepostDialogShow = true
    },
    handleCheckMilepost(id) {
      this.milePostId = id
      this.milepostDialogShow = true
    },
    handleNewSubproject() {
      this.newSubprojectDialogShow = true
    },
    handleAddSubproject() {
      this.addSubprojectDialogShow = true
    },
    //弹窗关闭
    handleDialogClose(type) {
      if (type === 'milepostDialogShow') {
        //里程碑弹窗
        this.milePostId = 0
        this.milepostDialogShow = false
      } else if (type === 'newSubprojectDialogShow') {
        //新增子项目弹窗
        this.newSubprojectDialogShow = false
      } else if (type === 'addSubprojectDialogShow') {
        //添加子项目弹窗
        this.addSubprojectDialogShow = false
      }
    },
    async fetchProjectUnreadMessage() {
      const param = {
        cross_project_id: this.id,
        is_read: 0,
        page: 1,
        pre_page: 1
      }
      const res = await apiMsg.historyMessageLogs(param)
      if (res) {
        this.messageListTotal = res.total
      }
    },
    async colorChange(val) {
      let {id, background_color, background_text} = val
      await projectApi.updateCrossProjectsBackground({id,background_color ,background_text})
      this.projectInfo.background_color = background_color
      this.projectInfo.background_text = background_text
    },
    // 背景颜色浮窗显示时 浮窗文字需隐藏
    colorVisibleChange(val) {
      this.colorTooltip = val ? false : false
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.project-cross-team-detail {
  // position: relative;
  padding: 24px 0;
  box-sizing: border-box;
  // .activeStyle {
  //   &:hover {
  //     color: #2682FF !important;
  //     i, p {
  //       color: #2682FF !important;
  //     }
  //   }
  //   &:active {
  //     color: #0463D6;
  //     i, p {
  //       color: #0463D6 !important;
  //     }
  //   }
  // }
  .project-cross-team-detail-top {
    width: 100%;
    height: 22px;
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .project-name {
      display: flex;
      align-items: center;
      .iconicon_arrow_task_2 {
        font-size: 16px;
        cursor: pointer;
      }
      .tool-tip {
        font-size: 18px;
        font-weight: 500;
        color: #0D1F3C;
        margin: 0 16px;
      }
      .iconicon_help_nor {
        font-size: 15px;
        cursor: pointer;
        color: rgba(13, 31, 60, .4);
      }
      .project-bread-color {
        margin-left: 10px;
        display: inline-flex;
        &:hover {
          filter:brightness(90%);
        }
      }
    }
    .project-set-wrap {
      display: flex;
      align-items: center;
      em {
        display: block;
        width: 1px;
        height: 16px;
        background: #202028;
        opacity: 0.16;
        margin: 0 23px 0 15px;
      }
      .iconicon_settings_nor {
        cursor: pointer;
        font-size: 14px;
        margin-right: 8px;
        color: rgba(13, 31, 60, .6);
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: rgba(13, 31, 60, .8);
      }
      .project_set {
        margin-left: 31px;
      }
    }
  }
  .project-container {
    display: flex;
    margin: 22px 0 40px;
    border-top: 1px solid rgba(32, 32, 32, .04);
    border-bottom: 1px solid rgba(32, 32, 32, .04);
    .progress {
      width: 333px;
      height: 240px;
      padding-top: 48px;
      box-sizing: border-box;
      border-right: 1px solid rgba(32, 32, 32, .04);
      .circular-progress-wrap {
        margin: 0 auto 25px;
      }
      // .container {
      //   width: 146px;
      //   height: 146px;
      //   .wave {
      //     width: 146px;
      //     height: 146px;
      //   }
      // }
      .progress-text {
        display: flex;
        align-items: center;
        justify-content: center;
        .progress-text-box {
          width: 42px;
          text-align: center;
          &:first-child {
            margin-right: 88px;
          }
          span {
            display: block;
            text-align: center;
            font-size: 24px;
            line-height: 28px;
            font-weight: bold;
            @include fontColorOpacity(1);
            margin-bottom: 4px;
            &.expire {
              color: #FF3939;
            }
          }
          p {
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            @include fontColorOpacity(.6);
          }
        }
      }
    }
    .milepost {
      flex: 1;
      width: 0;
      height: 240px;
      padding: 27px 0 0;
      box-sizing: border-box;
      position: relative;
      display: flex;
      flex-direction: column;
      .milepost-top {
        padding: 0 24px 0 32px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .milepost-top-left {
          display: flex;
          align-items: center;
          img {
            display: block;
            width: 16px;
            height: 16px;
          }
          i {
            font-size: 16px;
          }
          p {
            font-size: 16px;
            font-weight: 500;
            color: #0D1F3C;
            // margin: 0 16px 0 8px;
          }
          span {
            font-size: 14px;
            font-weight: 400;
            color: rgba(13, 31, 60, .6);
          }
        }
        .milepost-top-right {
          position: absolute;
          right: 24px;
          top: 24px;
          display: flex;
          align-items: center;
          padding: 8px;
          cursor: pointer;
          i {
            font-size: 14px;
            // height: 12px;
            margin-right: 8px;
            color: rgba(13, 31, 60, .6);
          }
          p {
            font-size: 14px;
            font-weight: 400;
            color: rgba(13, 31, 60, .8);
          }
        }
      }
      .nothing-box {
        top: 72px;
        transform: translate(-50%, 0);
        .imgs {
          margin: 0 auto;
          width: 120px;
        }
        img {
          width: 120px;
        }
        .tip {
          margin-bottom: 0;
        }
      }
      .milepost-con {
        position: relative;
        flex: 1;
        height: 0;
        overflow-x: scroll;
        // padding: 0 38px;
        .line-wrap {
          position: relative;
          padding-top: 41px;
          margin-left: 80px;
          .line {
            display: block;
            width: 100%;
            height: 1px;
            border-top: 1px dashed rgba(13, 31, 60, 0.16);
          }
          .is-finish {
            position: absolute;
            left: 0;
            top: 6px;
            display: block;
            width: 100%;
            height: 5px;
            background:  linear-gradient(225deg, rgba(78, 184, 255, 1), rgba(38, 130, 255, 1));
          }
        }
        ul {
          position: absolute;
          left: 16px;
          top: 27px;
          z-index: 9;
          display: flex;
          li {
            width: 128px;
            margin-right: 80px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            &:last-child {
              margin-right: 16px;
            }
            // &.finish {
            //   .point {
            //     background: #CCE2FF;
            //     border: 4px solid #2682FF;
            //   }
            // }
            // &:first-child {
            //   .point {
            //     background: #C8E7DE;
            //     border: 4px solid #1A9A75;
            //   }
            // }
            .point-wrap {
              position: relative;
              span {
                display: flex;
                justify-content: center;
                width: 28px;
                height: 28px;
                line-height: 28px;
                border-radius: 50%;
              }
              .point {
                font-size: 28px;
                color: #2682FF;
                background: #fff;
              }
              .num {
                background: #D6D9DD;
                font-size: 12px;
                color: rgba(13, 31, 60, .6);
                &:hover {
                  background: #C3C6CB;
                }
                &:active {
                  background: #ADB0B6;
                }
              }
            }
            .tool-tip {
              font-size: 16px;
              font-weight: 400;
              color: #0D1F3C;
              margin: 16px 0 8px;
              // max-width: 128px;
              // @include ellipsis();
            }
            .date {
              font-size: 14px;
              font-weight: 400;
              color: rgba(13, 31, 60, .6);
            }
          }
        }
      }
    }
  }
  .project-child {
    padding: 0 24px;
    box-sizing: border-box;
    .project-child-top {
      width: 100%;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      .project-child-top-left {
        display: flex;
        align-items: center;
        img {
          display: block;
          width: 16px;
          height: 16px;
        }
        i {
          font-size: 16px;
        }
        p {
          font-size: 16px;
          font-weight: 500;
          color: #0D1F3C;
          // margin: 0 16px 0 8px;
        }
        span {
          font-size: 14px;
          font-weight: 400;
          color: rgba(13, 31, 60, .6);
        }
      }
      .project-child-right {
        .el-dropdown-link {
          display: flex;
          align-items: center;
          padding: 8px;
          border-radius: 4px;
          cursor: pointer;
        }
        i {
          font-size: 14px;
          margin-right: 8px;
          color: rgba(13, 31, 60, .6);
        }
        p {
          font-size: 14px;
          font-weight: 400;
          color: rgba(13, 31, 60, .8);
        }
      }
    }
    .project-child-container {
      display: flex;
      flex-wrap: wrap;
      position: relative;
      .nothing-box {
        top: 200px;
      }
    }
  }
}
</style>
